import {
  MANAGE_MEDIA_UPLOAD,
  MANAGE_GET_EXISTING_IMAGES,
  MANAGE_GET_PRESIGNED_URL,
  MANAGE_MARK_FILE_AS_UPLOADED,
  MANAGE_MEDIA_ADD,
  MANAGE_MEDIA_RESET,
  REMOVE_ASSIGNED_MEDIA,
  MANAGE_MEDIA_UPLOAD_LAB_REPORT,
  MANAGE_MEDIA_UPLOAD_APPRAISAL
} from 'constants/action-types';

const initialState = {
  uploadedImages: [],
  existingImages: {
    items: [],
    pagination: {}
  },
  imageToUpload: [],
  uploadedImagesWithUrls: [],
  countUploadedImages: 0,
  labReportsFiles: [],
  appraisalFiles: []
};

export const manageMedia = (state = initialState, action) => {
  switch (action.type) {
    case MANAGE_GET_PRESIGNED_URL.pending: {
      return {
        ...state,
        imageToUpload: action.meta.files,
        uploadedImagesWithUrls: []
      };
    }
    case MANAGE_MARK_FILE_AS_UPLOADED.success: {
      return {
        ...state,
        countUploadedImages: state.countUploadedImages + 1
      };
    }
    case MANAGE_GET_PRESIGNED_URL.success: {
      return {
        ...state,
        uploadedImagesWithUrls: action.payload
      };
    }
    case MANAGE_GET_EXISTING_IMAGES.success: {
      return {
        ...state,
        existingImages: {
          items: action.meta.isLoadMore
            ? [...state.existingImages.items, ...action.payload.items]
            : action.payload.items,
          pagination: action.payload.pagination
        }
      };
    }
    case MANAGE_MEDIA_UPLOAD: {
      return {
        ...state,
        uploadedImages: [...state.uploadedImages, action.payload].map((i, idx) =>
          i.mediaId ? i : { ...i, mediaId: idx }
        ),
        imageToUpload: state.imageToUpload.filter(i => i.name === action.payload.fileName)
      };
    }
    case REMOVE_ASSIGNED_MEDIA: {
      return {
        ...state,
        uploadedImages: state.uploadedImages.filter(i => i.fileId !== action.payload.image.fileId)
      };
    }
    case MANAGE_MEDIA_RESET:
    case MANAGE_MEDIA_ADD.success: {
      return initialState;
    }
    case MANAGE_MEDIA_UPLOAD_LAB_REPORT.success: {
      return {
        ...state,
        labReportsFiles: [...action.payload]
      };
    }
    case MANAGE_MEDIA_UPLOAD_APPRAISAL.success: {
      return {
        ...state,
        appraisalFiles: [...action.payload]
      };
    }
    default:
      return state;
  }
};
